import { appConstantSettings } from 'srcReact/appConstantSettings'
import { globalSearchConstants as gs } from 'srcReact/SearchPage'
import { globalSearchService } from 'srcReact/services'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const globalSearchActions = {
  setSearchText,
  setFilterItem,
  setSearchSelectedMember,
  globalSearch,
  globalSearchPagination
}

function setFilterItem(filterItem) {
  return {
    type: gs.SET_FILTER_ITEM,
    filterItem
  }
}

function setSearchSelectedMember(searchSelectedMember) {
  return {
    type: gs.SET_SEARCH_SELECTED_MEMBER,
    searchSelectedMember
  }
}

function setSearchText(searchText) {
  return {
    type: gs.SET_SEARCH_TEXT,
    searchText
  }
}

function globalSearch(
  organization_id,
  search,
  latitude = 0,
  longitude = 0,
  filter = 'all',
  content_offset = 0,
  content_quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organization_id, search, latitude, longitude, filter, content_offset, content_quantity }))

    globalSearchService
      .globalSearch(organization_id, search, latitude, longitude, filter, content_offset, content_quantity)
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: gs.GET_GLOBAL_SEARCH_REQUEST, data }
  }
  function success(data) {
    return { type: gs.GET_GLOBAL_SEARCH_SUCCESS, data }
  }
  function failure(error) {
    return { type: gs.GET_GLOBAL_SEARCH_FAILURE, error }
  }
}

function globalSearchPagination(
  organization_id,
  search,
  latitude = 0,
  longitude = 0,
  filter = 'all',
  content_offset = 0,
  content_quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organization_id, search, latitude, longitude, filter, content_offset, content_quantity }))

    globalSearchService
      .globalSearch(organization_id, search, latitude, longitude, filter, content_offset, content_quantity)
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: gs.GET_GLOBAL_SEARCH_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: gs.GET_GLOBAL_SEARCH_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: gs.GET_GLOBAL_SEARCH_PAGINATION_FAILURE, error }
  }
}
